const regExp = RegExp(/^(?:\+?[0-9]{6,50})$/)

export const isPhoneValid = (phone: string): boolean => regExp.test(phone)

export default isPhoneValid
